<template>
  <div>

    <div class="container-xl">
      <div class="hade">
        <router-link to="/about"
          ><img
            src="../img/button icon@2x2.png"
            alt=""
          />&nbsp;预约口腔扫描</router-link
        >
      </div>
      <div class="row">
        <div class="step">
          <img src="../img/Group71642x.png" alt="" /><br />
          <span>选择诊所</span>
          <span>日期时间</span>
          <span style="color: #cccccc">联络资料</span>
        </div>
        <div class="col-lg-6 calendar">
          <div class="pc">
            <van-calendar
              :poppable="false"
              confirm-text="确认"
              title="日期选择"
              color="#00E467"
              v-model="show"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
              @confirm="onConfirm"
              :show-confirm="false"
              :style="{ height: '520px' }"
            />
          </div>
          <div class="move">
            <van-cell title="选择更多日期" :value="date" @click="show = true" />
            <van-calendar
              confirm-text="确认"
              title="日期选择"
              color="#00E467"
              v-model="show"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
              @confirm="onConfirm"
            />
          </div>
        </div>
        <div class="col-lg-6 choice">
          <div class="time-button" v-for="(value, index) in time" :key="index" v-if="city.id!=1007 || (city.id == 1007 && index != 24 && index != 25 && index != 26 && index != 27)">
            <div v-if="value <= 0">
              <button class="list-item" style="background-color: #eee" >
                <div v-if="[Number(index) ] <= 24">
                  上午{{ Math.floor(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "00" : "30"
                  }}-上午{{ Math.ceil(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "30" : "00"
                  }} (预约已满)
                </div>
                <div v-if="[index] > 24">
                  下午 {{ Math.floor(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "00" : "30"
                  }}-下午{{ Math.ceil(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "30" : "00"
                  }}
                  (预约已满)
                </div>
              </button>
            </div>
            <div v-else>
              <button
                @click="clickTime(index)"
                class="list-item"
                :style="start == index ? 'background-color:#00e567' : ''"
              >
                <div v-if="[Number(index) - 1] < 24">
                  上午{{ Math.floor(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "00" : "30"
                  }}-上午{{ Math.ceil(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "30" : "00"
                  }}
                </div>
                <div v-if="[index] > 24">
                  下午 {{ Math.floor(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "00" : "30"
                  }}-下午{{ Math.ceil(index / 2) }}:{{
                    Number(index) % 2 == 0 ? "30" : "00"
                  }}
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="nextStep">
          <button @click="childMethod()">下一步</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getByIdOutpatientEnable } from "@/api/outpatient";
export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/time'
    },{
      rel:'alternate',
      href:'https://mybeame.com/time',
      hrefLang:'x-default'
    }
    ]
  },


  data() {
    return {
      date: "",
      show: false,
      city: [{}],
      time: { },
      start: null,
      minDate: new Date(),
      maxDate: new Date(),
    };
  },
  mounted() {
    this.city = JSON.parse(localStorage.getItem("city")); //获取本地数据
    this.date = this.formatDate(new Date()); //获取当前时间
    this.sj(); //执行获取当天可以预约时间事件
    this.maxDate = this.getNewDay(14); //执行获取往后14天可以预约时间事件
  },

  methods: {
    //判断 节假日不可预约
    formatter(day) {
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();

      if (
        (month == "1" && date == "1") ||
        (month == "2" && date == "1") ||
        (month == "2" && date == "2") ||
        (month == "2" && date == "3") ||
        (month == "4" && date == "5") ||
        (month == "4" && date == "15") ||
        (month == "4" && date == "16") ||
        (month == "4" && date == "18" && this.city.id == "1001" && this.city.id != "1007") ||
        (month == "5" && date == "2" && this.city.id != "1007") ||
        (month == "5" && date == "9" && this.city.id != "1007") ||
        (month == "6" && date == "3" && this.city.id != "1007") ||
        (month == "7" && date == "1" && this.city.id != "1007") ||
        (month == "9" && date == "11" && this.city.id != "1007") ||
        (month == "10" && date == "1" && this.city.id != "1007") ||
        (month == "10" && date == "4" && this.city.id != "1007") ||
        (month == "12" && date == "26" && this.city.id != "1007") ||
        (month == "12" && date == "27" && this.city.id != "1007")
      ) {
        day.type = "disabled";
      }
      return day;
    },

    //当天时间显示
    formatDate(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      if (
        (month == "4" && day == "5") ||
        (month == "4" && day == "18" && this.city.id == "1001") ||
        (month == "5" && day == "2" && this.city.id != "1007") ||
        (month == "5" && day == "9" && this.city.id != "1007") ||
        (month == "6" && day == "3" && this.city.id != "1007") ||
        (month == "9" && day == "12" && this.city.id != "1007") ||
        (month == "10" && day == "1" && this.city.id != "1007") ||
        (month == "10" && day == "4" && this.city.id != "1007")
      ) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${
          date.getDate() + 1
        }`;
      }
      if ((month == "4" && day == "15") || (month == "12" && day == "26")) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${
          date.getDate() + 2
        }`;
      }
      // if (month == "4" && day == "15") {
      //   return `${date.getFullYear()}-${date.getMonth() + 1}-${
      //     date.getDate() + 4
      //   }`;
      // }
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;


      // if (date.getDay() == 3 && this.city.id == "1014") {
      //   this.day = date.getDate() + 1;
      //   return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()+1}`;
      // }
    },
    //执行获取往后14天不可以预约时间事件
    getNewDay(days) {
      var nDate = new Date();
      var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
      var rDate = new Date(millSeconds);
      var year = rDate.getFullYear();
      var month = rDate.getMonth() + 1;
      if (month < 10) month = "0" + month;
      var date = rDate.getDate();
      if (date < 10) date = "0" + date;
      return new Date(year + "-" + month + "-" + date);
    },

    //选择的日期
    onConfirm(date) {
      this.start = null;
      this.show = false;
      this.date = this.formatDate(date);
      var uresData = {
        id: this.city.id,
        day: this.date,
      };
      //发送选择的日期可预约时间请求
      getByIdOutpatientEnable(uresData).then((res) => {
        this.time = res.data;
      });
    },

    //下一步并判断是否选择时间
    childMethod() {
      if (this.start == null) {
        this.$message({
          message: "预约时间不能为空",
          type: "warning",
        });
        return;
      }
      //数据储存
      var time = {
        start: this.start,
        date: this.date,
      };
      localStorage.setItem("time", JSON.stringify(time));
      this.$router.push("/liaison");
    },

    //点击选择时间的事件
    clickTime(start) {
      this.start = start;
      this.end = (parseInt(start) + 1).toString();
    },

    //获取当天所有可以预约时间事件
    sj() {
      var uresData = {
        id: this.city.id,
        day: this.date,
      };
      // 获取所有可以预约时间请求
      getByIdOutpatientEnable(uresData).then((res) => {
        this.time = res.data;
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin: 0;
  background-color: #f2f2f2;
  margin-bottom: 150px;
}
.move {
  display: none;
}
.hade {
  width: 100%;
  padding: 10px 0;
  margin-top: 50px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
}
.hade > a {
  margin-left: 20px;
  font-weight: 700;
  display: flex;
  font-size: 19px;
}
.hade > a > img {
  width: 17px;
  height: 27px;
}

.step {
  font-size: 19px;
  text-align: center;
  background-color: #f2f2f2;
}
.step > img {
  margin: 20px 0 12px 0;
  /* width: 40%;
  height: 30px; */
}
.step > span {
  font-weight: 700;
}
.step span:nth-child(4) {
  margin: 0 158px;
}
.calendar {
  margin-top: 30px;
}
.van-calendar {
  width: 90%;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(42, 59, 77, 0.2);
}
.choice {
  margin-top: 30px;
}

.van-cell {
  font-size: 18px;
  font-weight: 700;
  color: #323e48;
  border-radius: 100px;
  box-shadow: 0px 0px 6px 0px rgba(207, 13, 13, 0.185);
  width: 90%;
  height: 48px;
  margin: 0 auto;
  margin-top: 30px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
}
.van-cell__value {
  font-size: 18px;
  color: #323e48;
}
.time-button {
  text-align: center;
}
.list-item {
  font-size: 19px;
  width: 70%;
  padding: 8px 0 10px 0;
  /* height: 48px; */
  border: 0 none;
  margin-top: 10px;
  background: #ffffff;
  border-radius: 100px;
  box-shadow: 0px 0px 6px 0px rgba(42, 59, 77, 0.2);
}
.nextStep {
  text-align: center;
}
.nextStep > button {
  width: 30%;
  padding: 11px 0 11px 0;
  font-size: 21px;
  border: none;
  margin-top: 50px;
  margin-bottom: 30px;
  font-weight: 700;
  background: #00e467;
  border-radius: 0px 10px 0px 0px;
}
.el-notification {
  width: 90% !important;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}

@media all and (max-width: 992px) {
  .hade {
    margin-top: 0;
  }
  .nextStep > button {
    width: 60%;
    font-size: 17px;
  }
  .step > img {
    margin: 20px 0 12px 0;
    width: 249px;
    height: 16px;
  }
  .step span:nth-child(4) {
    margin: 0 52px;
  }
  .step {
    background-color: #ffffff;
  }
  .row {
    background-color: #ffffff;
  }
  .pc {
    display: none;
  }
  .move {
    display: block;
  }
  .van-cell{
    width: 70%;
  }
  .list-item {
    width: 70%;
  }
}
@media all and (max-width: 570px) {
  .nextStep > button {
    width: 80%;
    font-size: 17px;
  }
  .hade > a {
    margin-left: 20px;
    font-weight: 700;
    display: flex;
  }
  .list-item {
    width: 90%;
    font-size: 16px;
  }

  .hade > a > img {
    width: 14px;
    height: 26px;
  }
  .hade > a {
    font-size: 18px;
  }
  .step > span {
    font-size: 15px;
  }
  .van-popup >>> .van-button__text {
    font-size: 17px !important;
  }
  .van-cell {
    width: 90%;
    font-size: 17px !important;
  }
  .calendar {
    margin-top: 0;
  }
}
</style>